import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  onboardingPopupOpen: false,
};

const layoutSlice = createSlice({
  name: "layout",
  initialState,
  reducers: {
    onboardingPopupChanged: (state, action) => {
      state.onboardingPopupOpen = action.payload;
    },
    reset: (state) => {
      state = initialState;
    },
  },
});

export const layoutSliceReducer = layoutSlice.reducer;
export const layoutSliceActions = layoutSlice.actions;
